import { IUpdateContratoUseCase } from "../../../presentation/useCases/update/update_contrato_use_case";
import {  ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

// UpdateContratoUseCase


export class UpdateContratoUseCase implements IUpdateContratoUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async updateContrato(
  IdContrato: number, Status: number | null, NumeroContrato: string | null, Escopo: string | null, DataDe: Date | null, DataAte: Date | null, IdCentroCusto: number | null, IdFornecedor: number | null, StatusPcmat: number | null, StatusPcmso: number | null, ValorContrato: number | null, ValorMedido: number | null, ValorRestante: number | null, ContratoAssinado?: string | null
  ): Promise<void> {
    
    await this.repository.updateContrato(
      IdContrato, Status, NumeroContrato, Escopo, DataDe, DataAte, IdCentroCusto, IdFornecedor, StatusPcmat, StatusPcmso, ValorContrato, ValorMedido, ValorRestante, ContratoAssinado
    );
  }
}
